export class OstkFailure
{
    error: {
        body: {
            badRequest: {
                message: string;
                code: number;
            };
            conflictingRequest: {
                message: string;
                code: number;
            };
            NeutronError: {
                detail: string;
                message: string;
                type: string;
            };
            error: {
                message: string;
            },
            message: string;
            request: string;
            response: string;
        };
    };
    headers: any;
    message: string;
    name: string;
    ok: boolean;
    status: number;
    statusText: string;
    url: string;

    public static MapperFromObject (source: any): OstkFailure
    {

        const target = new OstkFailure();

        Object.assign(target, source);

        return target;
    }
}
